export default __webpack_public_path__ + "static/thumb_lg_04-e3afac442dec63bbb30bf36cf7100a53.png";